export class AttendedFlagOrUnflag {
  public constructor() {
    this.Attended = false;
    this.AttendeeHeaderIds = new Array<number>();
    this.EventItemIds = new Array<number>();
  }

  public Attended: boolean;
  public AttendeeHeaderIds: Array<number>;

  public EventItemIds: Array<number>;
}
